import { Component, Input } from '@angular/core';
import { Step } from '@core/models/step.model';

@Component({
  selector: 'mfp-stepper-small',
  templateUrl: './stepper-small.component.html',
  styleUrls: ['./stepper-small.component.scss']
})
export class StepperSmallComponent {
  @Input() currentStep = 1;
  @Input() currentPercentage = 0;
  @Input() steps: Step[] = [];

  constructor() { }
}
